/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";
import { ImageSourcesType } from "../Image/types";
import Image from "../Image";

const ImageTile = React.forwardRef(
  (
    {
      imageClassName,
      format,
      title,
      onClick,
      href,
      sources,
      name,
      alt,
      childComponent,
    },
    ref,
  ) => {
    const hasSources = sources && Object.values(sources).length;
    const formatClasses = () => {
      let classes = "";
      switch (format) {
        case "portrait":
          classes = "aspect-w-7 aspect-h-10";
          break;
        case "square":
          classes = "aspect-w-1 aspect-h-1";
          break;
        case "landscape":
          classes = "aspect-w-16 aspect-h-9";
          break;
        default:
          break;
      }
      return classes;
    };
    return (
      <div
        data-testid="image-tile"
        ref={ref}
        onKeyUp={onClick}
        onClick={onClick}
        href={href}
        tabIndex={0}
        role="link"
        className="h-full block group cursor-pointer"
      >
        <div className={`h-full ${formatClasses()}`}>
          {hasSources ? (
            <Image
              className={`object-cover transform transition-transform group-hover:scale-105 filter ${
                !childComponent ? "drop-shadow rounded" : ""
              } ${imageClassName}`}
              alt={alt}
              sources={sources}
            />
          ) : (
            <div className="flex justify-center justify-items-center object-cover rounded text-center p-sm bg-gradient-to-tr from-gray-200 to-white hover:from-white transform transition-transform group-hover:scale-105 filter drop-shadow">
              <p
                className="gn-headline-lg text-gray-900 break-words group-hover:text-purple my-auto"
                style={{ WebkitHyphens: `auto`, hyphens: `auto` }}
              >
                {name}
              </p>
            </div>
          )}
        </div>
        {title ? (
          <h3 className="gn-text-sm mt-sm text-white">{title}</h3>
        ) : null}
      </div>
    );
  },
);

ImageTile.propTypes = {
  /** Classes to add to the Image component used inside the image tile */
  imageClassName: PropTypes.string,
  /** Sets the aspect ratio of the image */
  format: PropTypes.oneOf(["portrait", "square", "landscape"]),
  /** A title to display under the image */
  title: PropTypes.string,
  /** Content tag name */
  name: PropTypes.string,
  /** A function that will run when the tile is clicked */
  onClick: PropTypes.func,
  /** An href for the tile */
  href: PropTypes.string,
  /** A src set of images for the tile */
  sources: ImageSourcesType,
  /** Alt text */
  alt: PropTypes.string,
  /** When true, the tile will have sqaure corners and no shadows */
  childComponent: PropTypes.bool,
};

ImageTile.defaultProps = {
  imageClassName: "",
  format: "portrait",
  title: undefined,
  name: undefined,
  onClick: null,
  href: null,
  sources: {},
  alt: "",
  childComponent: false,
};

export default ImageTile;
